'use client';

import { useEffect } from 'react';

let isInitialized = false;

export default function LivePreviewInit() {
  useEffect(() => {
    if (isInitialized) return;
    // Gated on environment, not ?live_preview: the panel only appends that
    // param after the SDK connects, so requiring it up front deadlocks.
    if (process.env.NEXT_PUBLIC_VERCEL_ENV === 'production') return;
    isInitialized = true;

    import('@contentstack/live-preview-utils')
      .then(({ default: ContentstackLivePreview }) => {
        ContentstackLivePreview.init({
          enable: true,
          ssr: true,
          editButton: { enable: false },
          editInVisualBuilderButton: { enable: false },
          stackDetails: {
            apiKey: process.env.NEXT_PUBLIC_CONTENTSTACK_DELIVERY_API_KEY,
            environment: process.env.NEXT_PUBLIC_CONTENTSTACK_ENVIRONMENT,
          },
        });
      })
      .catch((error) => {
        // warn, not error: console.error auto-forwards to Datadog RUM.
        console.warn('[live-preview] failed to load or init the SDK:', error);
      });
  }, []);

  return null;
}
